import './style.sass';

import clsx from 'clsx';
import { sanitize } from 'isomorphic-dompurify';

// eslint-disable-next-line max-len
import FullWrapper from '~/components/features/cases/OldComponents/cases/reusable-components/layouts-components__common-cases/full-wrapper';

type ChallengeType = {
    title: string;
    text: string;
    sideText?: string;
};
type ChallengesPropsType = {
    challengesList: ChallengeType[];
};

function Challenges({ challengesList }: ChallengesPropsType) {
    return (
        <div className="moscowExchange-challenges">
            <FullWrapper isMargin={false} className="moscowExchange-challengesCase">
                <div className="moscowExchange-challengesWrapper">
                    <div className="moscowExchange-challengesInner">
                        <div className="moscowExchange-challengesLeft">
                            <div className="moscowExchange-challengesTitle">Вызовы проекта</div>
                        </div>
                    </div>
                    {challengesList.map(item => {
                        return (
                            <div
                                key={item.title}
                                className={clsx(
                                    'moscowExchange-challengesInner',
                                    'moscowExchange-challengesInnerMargin'
                                )}
                            >
                                <div className="moscowExchange-challengesLeft">
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: sanitize(item.title),
                                        }}
                                        className={clsx(
                                            'moscowExchange-challengesLeft',
                                            'challenges-title'
                                        )}
                                    />
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: sanitize(item.text),
                                        }}
                                        className={clsx('moscowExchange-challengesLeft')}
                                    />
                                </div>
                                {item.sideText && (
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: sanitize(item.sideText),
                                        }}
                                        className={clsx('moscowExchange-challengesRight')}
                                    ></div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </FullWrapper>
        </div>
    );
}

export default Challenges;
